export default "/* purgecss start ignore */\n\n/* purgecss end ignore */";